export default __webpack_public_path__ + "static/media/personalAccidentCover.0c4abf1e.svg";